export const buildArrayLength = length => {
    let l = [];
    for (let index = 0; index < length; index++) {
        l.push(index);
    }
    return l;
};

export const makeQuery = filters => {
    if (!filters) return '';

    const result = Object.keys(filters)
        .reduce(function(a, k) {

            if (filters[k] === null || typeof filters[k] === 'undefined' || 
                (typeof filters[k] === 'string' && !filters[k].toString().trim().length)) {
                return a;
            } else {
                if (k === 'type' && Array.isArray(filters[k]) && filters[k].length > 0) {
                    const values = filters[k].map(v => `"${v}"`).join(',');
                    const param = `${k}=[${values}]`;
                    a.push(param);
                }

                else if (Array.isArray(filters[k]) && filters[k].length > 0) {
                    filters[k].forEach(value => {
                        if (value !== null && typeof value !== 'undefined') {
                            let paramValue;
                            if (typeof value === 'object' && value !== null) {
                                paramValue = value.value || value._id || JSON.stringify(value);
                            } else {
                                paramValue = value.toString().trim();
                            }
                            
                            if (paramValue) {
                                const param = `${k}[]=${encodeURIComponent(paramValue)}`;
                                a.push(param);
                            }
                        }
                    });
                } 
                else if (typeof filters[k] === 'object' && filters[k] !== null) {
                    let paramValue;
                    
                    if (['status', 'substatus', 'enabled', 'assigned'].includes(k)) {
                        paramValue = filters[k].value || filters[k]._id || '';
                    } else {
                        paramValue = filters[k].value || filters[k]._id || JSON.stringify(filters[k]);
                    }
                    
                    if (paramValue) {
                        const param = `${k}=${encodeURIComponent(paramValue)}`;
                        a.push(param);
                    }
                }
                else {
                    const param = `${k}=${encodeURIComponent(filters[k].toString().trim())}`;
                    a.push(param);
                }
                return a;
            }
        }, [])
        .join('&');
    
    return result;
};

export const scrolly = (action, event) => {
    let element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        action();
    }
};

export const phoneIsValid = phone => /^\+?\d+$/.test(phone);

export const numberIsValid = number => /^\d+$/.test(number);

export const emailIsValid = email => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const rutIsValid = completeRut => {
    if (!completeRut) return false;
    let rut = completeRut.replace('-', '');
    if (rut.match(/^[̣0-9]+[0-9K]+[0-K]$/) === null) return false;
    let M = 0,
        S = 1;
    let T = rut.slice(0, -1);
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    let vd = S ? S - 1 : 'K';
    return vd.toString() === rut.slice(-1).toUpperCase();
};
